<template>
  <div id="app">
    <Header :page="page" :cartCount="cartCount"></Header>
    <Bar></Bar>
    <router-view @page="getPage" />
    <Footer></Footer>
  </div>
</template>

<script>
  import Home from './views/home/Index';
  import Footer from './components/Footer';
  import Header from './components/Header';
  import Bar from './components/Bar';

  import {
    mapGetters
  } from 'vuex';

  export default {
    name: 'app',
    components: {
      Home,
      Footer,
      Header,
      Bar
    },
    data() {
      return {
        page: 'home',
      };
    },
    methods: {
      getPage(value) {
        if (value == 'other') {
          this.page = value;
        } else {
          this.page = 'home';
        }
      },
    },
    created() {
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("store") && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage
        .getItem("userMsg"))));

      //在页面刷新时将vuex里的信息保存到localStorage里
      window.addEventListener("beforeunload", () => {
        localStorage.setItem("store", JSON.stringify(this.$store.state))
      })
    },
    mounted() {

      localStorage.setItem('page', 'home');
    },
  };
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }
</style>
